(function() {
	'use strict';

	angular
		.module('app.core')
		.controller('setupNavigation', setupNavigation);

	setupNavigation.$inject = ['$scope', '$rootScope', '$timeout', '$state', '$experiments', 'navigationService', 'siteService', 'storeService', 'userAttributes', 'oldNavMargin', 'oldNavMarginCollapsed'];

	function setupNavigation($scope, $rootScope, $timeout, $state, $experiments, navigationService, siteService, storeService, userAttributes, oldNavMargin, oldNavMarginCollapsed) {
		var COMPANY_LEVEL_MODULES = ['generalSettings', 'notifications', 'inventoryActions', 'leanProjectsCustomer', 'leanDNA', 'supplyChainCustomer'];
		var tabDefault = {
			'Company': 'app.setup.data-pipeline',
			'Site': 'app.setup.factory-general-settings'
		};
		var adminConfig = storeService.getState().adminConfig;
		var isSupplier = globalConfig.user.role === 'Supplier';
		var qParams = parseQueryString(window.location.href);
		var paramSettings;
		$scope.factoryName = globalConfig.factory.alias || globalConfig.factory.name;
		$rootScope.navProps = {};
		$rootScope.navProps.sidebarPinTitle = 'Click to hide.';
		$rootScope.navProps.hideSubNav = false;
		$rootScope.displayTabs.active = true;
		$rootScope.subView = {};
		$rootScope.authorizedAdminSites = siteService.getAdminSitesByCustomer(adminConfig.customer.id);
		$rootScope.currentSiteId = adminConfig.factory.id;
		$rootScope.banner = !isSupplier ? 'settings' : null;
		$scope.showReportTemplates = true;
		$scope.isWriteBackEnabled = siteService.isWriteBackEnabled();
		$scope.goToTabFirstView = navigationService.goToTabFirstView;

		if ($rootScope.authorizedAdminSites.length === 1) {
			$scope.factoryName = $rootScope.authorizedAdminSites[0].name;
		}



		// Only show report card params to morgan
		$scope.showReportCard = globalConfig.customer.id === 61;

		var HASH_PREFIX_USER_ATTRIBUTES = 'ass';

		function setAdminSite(siteId) {
			userAttributes.setHashed(HASH_PREFIX_USER_ATTRIBUTES, 'customer-' + adminConfig.customer.id, siteId);
		}

		$rootScope.selectAdminSite = function ($siteId) {
			if ($siteId !== adminConfig.factory.id) {
				var adminSite = _.find($rootScope.authorizedAdminSites, function (site) { return site.id === $siteId; });
				if (adminSite) {
					storeService.dispatch(storeService.actionCreators.setAdminFactoryConfig({
						factory: {
							id: adminSite.id,
							name: adminSite.name
						}
					}));
					setAdminSite($siteId);
					$timeout(function () {
						var currentUrl = window.location.href;
						var urlParts = currentUrl.split('?');
						if (urlParts.length > 1) {
							var params = parseQueryString(currentUrl);
							if (params.drilldownSettings) {
								delete params.drilldownSettings;
								var newQueryString = Object.keys(params).map(function (key) {
									return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
								}).join('&');
								var newUrl = urlParts[0] + (newQueryString ? '?' + newQueryString : '');
								window.history.replaceState({}, '', newUrl);
							}
						}
						$state.reload();
					}, 0);
				}
			}
		};

		if (qParams && qParams.drilldownSettings) {
			paramSettings = JSON.parse(decodeURIComponent(qParams.drilldownSettings));
			if (paramSettings && paramSettings.adminParams) {
				$rootScope.selectAdminSite(parseInt(paramSettings.adminParams));
			}
		}
		
		// Clean up banner when controller is destroyed
		$scope.$on('$destroy', function() {
			$rootScope.banner = null;
		});
	}
})();
